import { render, staticRenderFns } from "./OptionsBarreFiltres.vue?vue&type=template&id=28bcfc0a&"
import script from "./OptionsBarreFiltres.vue?vue&type=script&lang=js&"
export * from "./OptionsBarreFiltres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports